let scriptsLoaded = {};

export function loadScript(url) {

  function createScriptTag(url) {
    let scriptTag = document.createElement("script")
    scriptTag.src = url
    scriptTag.nonce = document.querySelector('meta[name="csp-nonce"]')?.content
    return scriptTag
  }

  let cachedPromise = scriptsLoaded[url]
  if (cachedPromise) {
    return cachedPromise
  } else {
    let promise = new Promise(function(resolve) {
      let scriptTag = createScriptTag(url)
      scriptTag.addEventListener('load', resolve)
      document.body.appendChild(scriptTag)
    })
    scriptsLoaded[url] = promise
    return promise
  }
}
